<div class="w-100 d-flex flex-column align-items-center justify-content-center">
  <div>
    <img
      src="../../../../assets/img/logo-enexdirecto.png"
      class="img-fluid mt-4 mb-5"
    />
  </div>

  <h2 class="text-center mb-4">Registro de Cuenta</h2>
</div>

<div class="register-container px-4 px-md-3 mb-5">
  <form style="width: 100%" [formGroup]="formRegistro" (submit)="registrar()">
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <input
          type="text"
          class="form-control form-control-big"
          formControlName="nombreEmpresa"
          placeholder="Nombre y/o razón empresa/ cliente"
          aria-label="Nombre y/o razón empresa/ cliente"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <input
          type="text"
          class="form-control"
          formControlName="rutEmpresa"
          placeholder="RUT empresa/cliente"
          aria-label="RUT empresa/cliente"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <input
          type="text"
          class="form-control"
          formControlName="nombreUsuario"
          placeholder="Nombre usuario administrador"
          aria-label="Nombre usuario administrador"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <input
          type="text"
          class="form-control"
          formControlName="rutCliente"
          placeholder="RUT usuario administrador"
          aria-label="RUT usuario administrador"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <input
          type="text"
          class="form-control form-control-big"
          formControlName="emailUsuario"
          placeholder="Correo usuario administrador"
          aria-label="Correo usuario administrador"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <input
          type="text"
          class="form-control"
          formControlName="telefonoEmpresa"
          placeholder="Teléfono"
          aria-label="Teléfono"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <re-captcha
          (resolved)="resolved($event)"
          [siteKey]="googleCaptchaSiteKey"
          formControlName="recaptchaReactive"
        ></re-captcha>
      </div>
    </div>

    <div class="row no-gutters">
      <div
        class="
          col-12 col-md-10
          mx-auto
          d-flex
          flex-column
          justify-content-center
        "
      >
        <button
          type="submit"
          [disabled]="formRegistro.invalid"
          class="btn btn-success btn-block mb-2"
        >
          <span *ngIf="!loader; else tmpLoader">Enviar Solicitud</span>
        </button>
        <a class="align-self-center mb-4" [routerLink]="['/auth']">Volver</a>
      </div>
      <a href="javascript:"></a>

      <div class="col-12 d-flex flex-column justify-content-center">
        <img
          src="../../../../assets/img/logo-enex.svg"
          class="img-fluid logo-enex mx-auto"
        />
      </div>
    </div>
  </form>
</div>

<ng-template #tmpLoader>
  <span class="spinner-border text-white" role="status">
    <span class="sr-only">Loading...</span>
  </span>
</ng-template>
